import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { ReactComponent as AddDeviceIcon } from "../../../src/assets/images/checkInAndOutDevice/AddDeviceIcon.svg";
import { ReactComponent as AddDeviceIconUSA } from "../../assets/USA_Images/adddeviceusa.svg";

import DataTableLatest from "../../components/DataTable/DataTableLatest";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";

import { REACT_INTEGRATION_LIST } from "../../actions/EndPoints";
import {
  addGenetecAccessLevelAndCardHolderToMSGP,
  getAccessLevelAndIntegrationLists,
} from "../../slices/GenetecSlices/GenetecSlices";

export default function AccessLevelRuleLists(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [genetecLists, setGenetecLists] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const [paging, setPaging] = useState({
    pageNumber: 1,
    pageSize: 50,
  });

  useEffect(() => {
    loadGenetecAccessLevel(paging);
  }, [paging]);

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);

    setPaging({
      pageNumber: newPage,
      pageSize: size,
    });
  };

  const loadGenetecAccessLevel = (paging) => {
    const query = {
      pageNumber: paging.pageNumber,
      pageSize: paging.pageSize,
      accessType: ["ACCESS_LEVEL", "ARMATURA_ACCESS_LEVEL"],
    };

    dispatch(getAccessLevelAndIntegrationLists(query))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && data.data) {
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setTotalRecords(data.data.totalCount);
          setGenetecLists(data.data.integrationDetails || []);
        } else {
          setGenetecLists([]);
        }
      })
      .catch(() => {
        setGenetecLists([]);
      });
  };

  const onSelectionRowdata = (ids) => {
    const selectedData = genetecLists.filter((row) => ids.includes(row.id));

    setSelectedRows(selectedData);
  };

  const saveAccessLevels = (rows) => {
    if (!rows || rows.length === 0) {
      Toast(t("COMMON019"), "warning");
      return;
    }

    const payload = {
      employeeId: props.location?.state?.id,
      accessLevel: rows.map((item) => ({
        id: item.integrationId,
        name: item.integrationName,
        integrationType: item.integrationType,
        accessType: item.accessType,
      })),
    };

    console.log("Payload => ", payload);

    dispatch(addGenetecAccessLevelAndCardHolderToMSGP(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4107") {
          Toast(t(res.message), "success");
          history.push({
            pathname: REACT_INTEGRATION_LIST,
            state: {
              id: props.location?.state?.id,
              integrationType: ["ACCESS_LEVEL", "ARMATURA_ACCESS_LEVEL"],
            },
          });
        } else {
          Toast(t(res.message), "error");
        }
      })
      .catch((err) => {
        Toast(err?.message || "Something went wrong", "error");
      });
  };

  // KEEP THIS
  const handleAddIconClick = (row) => {
    saveAccessLevels([row]);
  };

  const handleSubmit = () => {
    saveAccessLevels(selectedRows);
  };

  const columns = [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: () => <div />,
    },
    {
      field: "name",
      headerName: t("COMMON044"),
      flex: 1,
      valueGetter: (params) => params.row.integrationName,
    },
    {
      field: "integrationType",
      headerName: t("Integration Name"),
      flex: 1,
      valueGetter: (params) => params.row.integrationType || "",
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 1,
      width: 150,
      headerAlign: "center",

      getActions: (params) => [
        <GridActionsCellItem
          icon={
            process.env.REACT_APP_ENVIRONMENT === "USA" ? (
              <AddDeviceIconUSA />
            ) : (
              <AddDeviceIcon />
            )
          }
          label="Add"
          // FIXED HERE
          onClick={() => handleAddIconClick(params.row)}
        />,
      ],
    },
  ];

  return (
    <>
      <HeaderToolbar title={t("Integration Access Level")} back_button={true} />

      <Box
        display="flex"
        width="100%"
        flexDirection="row-reverse"
        alignItems="center"
        gap="5px"
      >
        <Tooltip title={t("COMMON002")}>
          <Box className="refreshIcon">
            <RefreshIcon onClick={() => loadGenetecAccessLevel(paging)} />
          </Box>
        </Tooltip>
      </Box>

      <DataTableLatest
        checkboxSelection
        columns={columns}
        rows={genetecLists}
        page={page}
        count={totalRecords}
        addAccessLevel={true}
        pageCount={totalPages}
        pageSize={rowsPerPage}
        handleChange={(newPage, size) => handleChange(newPage, size)}
        onSelectionModelChange={onSelectionRowdata}
      />

      <Grid
        style={{
          display: "flex",
          justifyContent: "end",
          margin: "15px 2px",
        }}
      >
        <CancelButtons
          variant="contained"
          color="secondary"
          onClick={() => history.goBack()}
          onClose={() => history.goBack()}
          cancel={() => history.goBack()}
          style={{ marginRight: "10px" }}
        >
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON008")}
          </Typography>
        </CancelButtons>

        <SubmitButtons variant="contained" onClick={handleSubmit}>
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON007")}
          </Typography>
        </SubmitButtons>
      </Grid>
    </>
  );
}
